import queryString from 'query-string';
import diacritics from 'diacritics';
import {camelize} from 'humps';
import UAParser from 'ua-parser-js';

export const isProduction = () => process.env.NODE_ENV.startsWith('production');

export const getViewportWidth = () => Math.max(window.innerWidth || 0);
export const getViewportHeight = () => Math.max(window.innerHeight || 0);
export const getViewportSize = () => ({width: getViewportWidth(), height: getViewportHeight()});
export const isMobile = () => new UAParser().getResult().device.type === 'mobile';
export const isLandscape = () => {
    const os = new UAParser().getResult().os;
    if (os.name === 'Android') { // Special case for 'Android' to handle it's keyboard
        const mediaQuery = '(min-device-aspect-ratio: 1/1) and (orientation: landscape)';
        return window.matchMedia(mediaQuery).matches;
    }
    return window.innerWidth > window.innerHeight;
};

export const getDOMNode = (selector, parent = document) => parent.querySelector(selector);
export const getDOMNodes = (selector, parent = document) => Array.from(parent.querySelectorAll(selector));
export const getStyleSheets = () => Array.from(document.styleSheets);

export const asciifold = value => diacritics.remove(value.toLowerCase());

export const padLeft = (value, length) => {
    value = value.toString();
    return value.length < length ? padLeft(`0${value}`, length) : value;
};

export const formatTime = (ms, pad = 2) => {
    let s = Math.floor(ms / 1000);
    let m = Math.floor(s / 60);
    const h = Math.floor(m / 60) % 24;
    s %= 60;
    m %= 60;
    return [padLeft(h, pad), padLeft(m, pad), padLeft(s, pad)].join(':');
};

export const toPX = value => `${value}px`;

export const range = length => [...Array(length).keys()];

export const castValue = value => {
    value = value.split(',');
    if (value.length <= 1) {
        value = value[0];
        if (/^\d+$/.test(value)) value = parseFloat(value);
        else if (String(value).toLowerCase() === 'true') value = true;
        else if (String(value).toLowerCase() === 'false') value = false;
    }
    return value;
};

export const getOptionsFromDataAttrs = domNode => {
    const options = {};
    Array.from(domNode.attributes).forEach(attr => {
        if (attr.name.substr(0, 4) === 'data') {
            const key = camelize(attr.name.substr(4));
            options[key] = castValue(attr.value);
        }
    });
    return options;
};

// https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/btoa#Unicode_strings
export const utoa = str => window.btoa(unescape(encodeURIComponent(str)));
export const atou = str => decodeURIComponent(escape(window.atob(unescape(str))));

const QS_OPTION_MAPPING = {
    wrapperId: 'w',
    startTime: 't',
    searchQuery: 'sq',
    searchTypes: 'st',
    searchPartial: 'sp',
};

export const putOptionsInQueryString = (options, qs) => {
    qs = queryString.parse(qs);
    const renamed = Object.entries(QS_OPTION_MAPPING)
        .reduce((values, [option, key]) => {
            values[key] = options[option];
            return values;
        }, {});
    const hasOptions = Object.values(renamed).some(v => v !== undefined);
    if (hasOptions) qs['cielo24-vwrap'] = utoa(queryString.stringify(renamed));
    return qs;
};

export const getOptionsFromQueryString = qs => {
    try {
        const encoded = queryString.parse(qs)['cielo24-vwrap'] || '';
        const renamed = queryString.parse(atou(encoded));
        return Object.entries(QS_OPTION_MAPPING).reduce((values, [option, key]) => {
            if (renamed[key]) values[option] = castValue(renamed[key]);
            return values;
        }, {});
    } catch (error) {
        console.error(error); // eslint-disable-line no-console
        return {};
    }
};

export const parseUrl = url => {
    const parser = document.createElement('a');
    parser.href = url;
    return parser;
};



// WEBPACK FOOTER //
// ./scripts/utils/index.js